<template>
  <flex-wrapper>
    <span
      class="flex items-center px-2 py-1 ml-6 text-xs font-semibold border rounded-lg cursor-pointer lg:text-sm lg:ml-2 font-quietSans text-foundationGrey900 border-foundationGreyG30 bg-foundationGreyG20"
      @click="triggerDownload"
      style="height: 40px"
    >
      <span>
        {{ text }}
      </span>
      <span class="ml-2">
        <img src="@/assets/svg/export.svg" class="w-4"/>
      </span>
    </span>
  </flex-wrapper>
</template>

<script>
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";
export default {
  props: ["text"],
  components: { FlexWrapper },
  methods: {
    triggerDownload() {
      this.$emit("download");
    },
  },
};
</script>

<style></style>
